import LinkNav from 'components/partials/links/components/link-nav/LinkNav';
import { getFileLink, getPageLink } from 'helpers/resources';

import DropdownWrapper from '../DropdownWrapper';

const FaqNavGroup = () => {
  return (
    <DropdownWrapper>
      <LinkNav to={getPageLink('page-faqs')} className="nav-link">
        FAQs & Forms
      </LinkNav>
      <div className="dropdown-menu">
        <div className="dropdown-wrapper">
          <div className="links-title">
            <LinkNav to={getPageLink('page-faqs')}>FAQs & Forms</LinkNav>
            <p>
              These important questions and answers will help you make an
              informed decision when it comes time to purchase life insurance.
            </p>
          </div>
          <div className="two-column">
            <div>
              <LinkNav to={getPageLink('page-faqs')} className="dropdown-item">
                FAQs
              </LinkNav>
              <LinkNav
                to={getPageLink('page-live-calculator')}
                className="dropdown-item"
              >
                How much life insurance do I need
              </LinkNav>
              <LinkNav
                to={getPageLink('page-fr-calculators-auto-loan')}
                className="dropdown-item"
              >
                Auto Loan Calculator
              </LinkNav>
              <LinkNav
                to={getPageLink('page-fr-calculators-amortization')}
                className="dropdown-item"
              >
                Loan Amortization Calculator
              </LinkNav>
            </div>
            <div>
              <LinkNav
                to={getFileLink('file-credit-auth')}
                className="dropdown-item"
                data-gtm-cc-authorization-form-link
              >
                <i className="icon-pdf" aria-hidden="true"></i>
                {'  '}
                Credit Card Authorization Form
              </LinkNav>
              <LinkNav
                to={getFileLink('file-beneficiary-designation-form')}
                className="dropdown-item"
                data-gtm-beneficiary-designation-form-link
              >
                <i className="icon-pdf" aria-hidden="true"></i>
                {'  '}
                Beneficiary Designation Form
              </LinkNav>
              <LinkNav
                to={getFileLink('file-eft-form')}
                className="dropdown-item"
                data-gtm-electronic-funds-transfer-form-link
              >
                <i className="icon-pdf" aria-hidden="true"></i>
                {'  '}
                Electronic Funds Transfer
              </LinkNav>
              <LinkNav
                to={getFileLink('file-request-for-allotment')}
                className="dropdown-item"
                data-gtm-allotment-request-form-link
              >
                <i className="icon-pdf" aria-hidden="true"></i>
                {'  '}
                Allotment Request Form
              </LinkNav>
              <LinkNav
                to={getFileLink('file-metlaw-mba-enrollment-fillable-2024')}
                className="dropdown-item"
                data-gtm-metlaw-legal-services-form-link-2024
              >
                <i className="icon-pdf" aria-hidden="true"></i>
                {'  '}
                MetLife Legal Plans
              </LinkNav>
            </div>
          </div>
        </div>
      </div>
    </DropdownWrapper>
  );
};

export default FaqNavGroup;
